import { MessageService, type Chat, type Message, type SearchMessagesData } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useMessagesSearch = () => {
  type SearchQuery = NonNullable<SearchMessagesData['query']>;
  type SearchPage = { hasNextPage: boolean; messages: Message[] };

  const { isLoading, send } = useFetchComposable(
    ({
      chatId,
      limit,
      page,
      query,
    }: {
      chatId: Chat['id'];
      limit: number;
      page: number;
      query: string;
    }) => {
      const requestQuery: SearchQuery = { limit, page, query };
      return MessageService.searchMessages({ path: { id: chatId }, query: requestQuery });
    },
  );

  const searchMessages = async (input: {
    chatId: Chat['id'];
    limit: number;
    page: number;
    query: string;
  }): Promise<SearchPage | null> => {
    const result = await send(input);
    return result.isSuccess && result.data
      ? { hasNextPage: result.data.hasNextPage ?? false, messages: result.data.messages ?? [] }
      : null;
  };

  return { isLoading, searchMessages };
};

export { useMessagesSearch };
